import { createAsyncThunk } from '@reduxjs/toolkit';
import apiBilling from '@/lib/api/billing';
import { IUserSlice } from '@/redux/slices/user/types';

export const getCallCredit = createAsyncThunk(
  'user/getCallCredit',
  apiBilling.getCallCredit
);

const fulfilled = (
  state: IUserSlice,
  {
    payload,
  }: {
    payload: {
      balance: number;
    };
  }
) => {
  state.user.call_credit = payload;
};

const rejected = (state: IUserSlice) => {
  state.user.call_credit = null;
};

export default {
  action: getCallCredit,
  fulfilled,
  rejected,
};
